
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState('overview', {
      data: 'facadestops'
    })
  } // computed
}; // export default
